module.exports = __webpack_public_path__ + "img/icon5@2x.623f38ca.png";